export const guardarStringLocal = ({key, dato}) => {



    window.localStorage.setItem(key, dato)

}